import { render, staticRenderFns } from "./DHV.vue?vue&type=template&id=b47d54b2&scoped=true"
import script from "./DHV.vue?vue&type=script&lang=js"
export * from "./DHV.vue?vue&type=script&lang=js"
import style0 from "./DHV.vue?vue&type=style&index=0&id=b47d54b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d54b2",
  null
  
)

export default component.exports